import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, LinkIcon, SparklesIcon, MonitorIcon, GraduationCapIcon, NetworkIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: '01',
    title: 'Diagnosticamos',
    description: 'Realizamos estudios, diagnósticos y evaluaciones para identificar las necesidades institucionales, operativas y tecnológicas de cada organización social.',
    icon: <SearchIcon className="w-8 h-8 text-white" data-id="element-284" />,
    color: 'bg-brand-royal',
    delay: 0.1
  }, {
    number: '02',
    title: 'Fortalecemos',
    description: 'Implementamos programas de capacitación, asistencia técnica, herramientas digitales y soluciones de automatización para modernizar y optimizar la gestión organizacional.',
    icon: <MonitorIcon className="w-8 h-8 text-white" data-id="element-285" />,
    color: 'bg-brand-crimson',
    delay: 0.3
  }, {
    number: '03',
    title: 'Articulamos',
    description: 'Generamos alianzas estratégicas con empresas, academia, sector público y organismos internacionales para crear redes de colaboración y proyectos de beneficio social.',
    icon: <NetworkIcon className="w-8 h-8 text-white" data-id="element-286" />,
    color: 'bg-brand-gold',
    delay: 0.5
  }, {
    number: '04',
    title: 'Proveemos',
    description: 'Proveemos soluciones tecnológicas y operativas para mejorar la gestión de las organizaciones.',
    icon: <SparklesIcon className="w-8 h-8 text-white" data-id="element-287" />,
    color: 'bg-brand-navy',
    delay: 0.7
  }];
  return <section id="como-funciona" className="py-24 bg-brand-lightGray relative" data-id="element-288">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-289">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-290">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-brand-royal font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-291">
            Metodología
          </motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-heading font-bold text-brand-navy mb-6" data-id="element-292">
            ¿Cómo generamos impacto?
          </motion.h3>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-gray-600" data-id="element-293">
            Mediante programas, proyectos y servicios de apoyo, acompañamos a
            las organizaciones sociales en cada etapa de su fortalecimiento.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative" data-id="element-294">
          {/* Connecting Line for Desktop */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gray-200 z-0" data-id="element-295"></div>

          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: step.delay,
          duration: 0.6
        }} className="relative z-10 flex flex-col items-center text-center group" data-id="element-296">
              <div className={`w-24 h-24 rounded-full ${step.color} flex items-center justify-center shadow-xl mb-8 transform group-hover:scale-110 transition-transform duration-300 ring-8 ring-brand-lightGray`} data-id="element-297">
                {step.icon}
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 h-full w-full group-hover:shadow-md transition-shadow" data-id="element-298">
                <span className="text-5xl font-heading font-black text-gray-100 absolute top-4 right-6 -z-10 select-none" data-id="element-299">
                  {step.number}
                </span>
                <h4 className="text-2xl font-heading font-bold text-brand-navy mb-4" data-id="element-300">
                  {step.title}
                </h4>
                <p className="text-gray-600 leading-relaxed" data-id="element-301">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}